import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useSearchZustandStore } from '@/helpers/searchctx.js';

/*
format filtersOutput {
  slug
  keySlugs [
    {
      output
    }
  ]
}
*/
// LISTEN and build all filters output, selected from url , by user
function FilterEvents() {
  const filterEvent = useSearchZustandStore((state) => state.filterEvent);

  const setStoreData = () => {
    const filtersOutput = filterEvent.data || [];
    const urls = filtersOutput.reduce((acc, f) => {
      const urlsExist = acc.find((u) => u.slug === f.slug);
      if (urlsExist) {
        urlsExist.values.push(f.url);
      } else {
        acc.push({
          slug: f.slug,
          values: [f.url],
        });
      }
      return acc;
    }, []);

    // console.log('search/events/filters - urls', urls);

    let options = {
      filtersOutput,
      urls,
    };

    // console.log('search/events/filters - setStoreData called', options);
    // Emitter.emit('search_map_build_clearAllMarkers', true)
    if (filterEvent.action !== 'initFilters') {
      options = {
        ...options,
        searchEvent: { action: 'runSearchFromFilter' },
        userUsingPlateform: nanoid(),
      };
    }
    useSearchZustandStore.setState(options);
  };

  useEffect(() => {
    if (filterEvent !== 'notready' && filterEvent?.action) {
      // console.log('search/events/filters - useEffect filterEvent ', filterEvent?.action);
      setStoreData();
    }
  }, [filterEvent]);

  return null;
}

// mapEvent: {action: 'runSearchFromFilter'}
export default FilterEvents;
